import { Controller } from "stimulus"
import { useClickOutside } from "stimulus-use"
import {enter, leave} from "el-transition"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    useClickOutside(this)
  }

  disconnect() {
    this.hideAll()
  }

  toggle(event) {
    this.dropdownTarget.classList.toggle("hidden")
  }

  clickOutside() {
    this.hideAll()
  }

  hideAll() {
    this.dropdownTarget.classList.add("hidden")
  }
}
